import { Formik } from "formik";
import React from "react";

const FormikContainer = ({
    initialValues,
    validationSchema,
    onSubmit,
    children,
    ...rest
}) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={onSubmit}
            {...rest}
        >
            {children}
        </Formik>
    );
};

export default FormikContainer;
